import "../css/contact.css";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaFacebook,
  FaInstagram,
  FaTwitter
} from "react-icons/fa";

function Contact() {
  return (
    <div className="contact-page">

      <div className="contact-banner">
        <h1>Contact SIPS LIQUOR</h1>
        <p>
          We're here to help. Contact our team for orders,
          products, delivery, and customer support.
        </p>
      </div>

      <div className="contact-container">

        <div className="contact-info">

          <h2>Get In Touch</h2>

          <div className="info-box">
            <FaMapMarkerAlt className="icon" />
            <div>
              <h4>Store Address</h4>
              <p>
                SIPS LIQUOR<br />
                323 N New Braunfels Ave ste 102<br />
                San Antonio, Texas 78202<br />
                United States
              </p>
            </div>
          </div>

          <div className="info-box">
            <FaPhoneAlt className="icon" />
            <div>
              <h4>Phone</h4>
              <p>+1 (210) 248-9916</p>
            </div>
          </div>

          <div className="info-box">
            <FaEnvelope className="icon" />
            <div>
              <h4>Email</h4>
              <p>sipsliquor@shopat1stop.com </p>
            </div>
          </div>

          <div className="info-box">
            <FaClock className="icon" />
            <div>
              <h4>Business Hours</h4>
              <p>
                Monday - Saturday<br />
                9:00 AM - 10:00 PM
              </p>
            </div>
          </div>

          <div className="social-icons">

            <FaFacebook />

            <FaInstagram />

            <FaTwitter />

          </div>

        </div>

        <div className="contact-form">

          <h2>Send Us a Message</h2>

          <form>

            <input
              type="text"
              placeholder="Full Name"
            />

            <input
              type="email"
              placeholder="Email Address"
            />

            <input
              type="text"
              placeholder="Phone Number"
            />

            <textarea
              rows="6"
              placeholder="Write your message..."
            ></textarea>

            <button>
              Send Message
            </button>

          </form>

        </div>

      </div>

    </div>
  );
}

export default Contact;